import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { SELECT_CLEAR } from '@/components/ui/select-sentinels'
import { setCloudReportFilters } from '../../Reports/reports.slice'
import { FilterOperators } from '../../Reports/reports.constants'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
	selectCloudReportFilters,
	selectCloudTiers,
} from '../../Reports/reports.selectors'

const CloudTierDropdownHeaderFilter = () => {
	const dispatch = useDispatch()
	const reportFilters = useSelector(selectCloudReportFilters)
	const cloudTiers = useSelector(selectCloudTiers)
    return (
        <Select
            value={reportFilters.cloudTier || SELECT_CLEAR}
            onValueChange={(val) => {
                if (val === SELECT_CLEAR) {
                    dispatch(
                        setCloudReportFilters({
                            ...reportFilters,
                            cloudTierId: null,
                            cloudTier: null,
                        })
                    )
                } else {
                    const selected = cloudTiers.find((x) => String(x.tierName) === String(val))
                    if (selected) {
                        dispatch(
                            setCloudReportFilters({
                                ...reportFilters,
                                cloudTierId: {
                                    filterValue: selected.id,
                                    filterOperationType: FilterOperators.Equal,
                                },
                                cloudTier: selected.tierName,
                            })
                        )
                    }
                }
            }}
        >
            <SelectTrigger className='w-full'>
                <SelectValue placeholder='Select a Plan' />
            </SelectTrigger>
            <SelectContent>
                <SelectItem value={SELECT_CLEAR}>Select a Plan</SelectItem>
                {cloudTiers && cloudTiers.map((cldTier) => (
                    <SelectItem key={cldTier.id} value={cldTier.tierName}>
                        {cldTier.tierName}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    )
}

export default CloudTierDropdownHeaderFilter
